<template>
  <div class="body">
    <!--    <divider/>-->
    <div>
      <div style="border-bottom: 1px solid #ddd; margin-bottom: 10px; padding-bottom: 5px; font-size: 16px">基本信息
      </div>
      <table class="gridtable" style="width: 100%" cellpadding="0" cellspacing="0">
        <tbody>
        <tr>
          <td class="tableLabel">编号</td>
          <td class="tdContent">{{ supplierApplicationVO.no }}</td>
          <td class="tableLabel">物料开发原因</td>
          <td class="tdContent">{{ supplierApplicationVO.importReason }}</td>
          <td class="tableLabel">是否有替换料</td>
          <td class="tdContent">{{ supplierApplicationVO.canReplace }}</td>
          <td class="tableLabel">客户名称</td>
          <td class="tdContent">{{ supplierApplicationVO.customerName }}</td>
        </tr>
        <tr>
          <td class="tableLabel">成品型号</td>
          <td class="tdContent">{{ supplierApplicationVO.productSpecification }}</td>
          <td class="tableLabel">物料名称</td>
          <td class="tdContent">{{ supplierApplicationVO.materialName }}</td>
          <td class="tableLabel">物料属性</td>
          <td class="tdContent">{{ supplierApplicationVO.materialProperty }}</td>
          <td class="tableLabel">物料代码</td>
          <td class="tdContent">{{ supplierApplicationVO.materialCode }}</td>
        </tr>
        <tr>
          <td class="tableLabel">需要符合</td>
          <td class="tdContent">{{ supplierApplicationVO.standardType }}</td>
          <td class="tableLabel">规格书</td>
          <td class="tdContent">{{ supplierApplicationVO.specification }}</td>
          <td class="tableLabel">物料使用类型</td>
          <td class="tdContent">{{ supplierApplicationVO.useType }}</td>
          <td class="tableLabel">创建时间</td>
          <td class="tdContent">{{ supplierApplicationVO.createTime }}</td>
        </tr>
        <tr>
          <td class="tableLabel">备注</td>
          <td class="tdContent" colspan="8">{{ supplierApplicationVO.note }}</td>
        </tr>
        <tr>
          <td class="tableLabel">供应商名称</td>
          <td class="tdContent">{{ supplierApplicationVO.supplierName }}</td>
          <td class="tableLabel">供方联系人</td>
          <td class="tdContent">{{ supplierApplicationVO.supplierContact }}</td>
          <td class="tableLabel">供方联系方式</td>
          <td class="tdContent">{{ supplierApplicationVO.supplierTel }}</td>
          <td class="tableLabel">供应商性质</td>
          <td class="tdContent">{{ supplierApplicationVO.supplierType }}</td>
        </tr>
        <tr>
          <td class="tableLabel">现有供应商</td>
          <td class="tdContent">{{ supplierApplicationVO.currentSupplier }}</td>
          <td class="tableLabel">常规性物料</td>
          <td class="tdContent">{{ supplierApplicationVO.materialStandard }}</td>
          <td class="tableLabel">与其他物料公用RoHS</td>
          <td class="tdContent">{{ supplierApplicationVO.roHS }}</td>
          <td class="tableLabel">其他物料</td>
          <td class="tdContent">{{ supplierApplicationVO.roHSMaterial }}</td>
        </tr>
        <tr>
          <td class="tableLabel">{{ supplierApplicationVO.materialProperty }}</td>
          <td class="tdContent" colspan="8">{{ supplierApplicationVO.materialPropertyValue }}</td>
        </tr>
        </tbody>
      </table>
    </div>
    <!--    <div-->
    <!--        style="text-align: center;border-bottom: 1px solid #ddd; margin-bottom: 10px; padding-bottom: 5px; font-size: 16px">-->
    <!--    </div>-->
    <divider/>
    <div>
      <table class="gridtable" style="width: 100%" cellpadding="0" cellspacing="0">
        <tbody>
        <tr v-if="showQuality">
          <td class="tableLabel">测试报告</td>
          <td class="tdContent">
            <div v-if="disabledQuality">
              {{supplierApplicationVO.testReport}}
            </div>
            <div v-else>
              <el-checkbox-group v-model="testReport" :max="1" @change="changeTestReport()">
                <el-checkbox label="有"/>
                <el-checkbox label="无(有供方出厂检验报告)"/>
              </el-checkbox-group>
            </div>
          </td>
          <td class="tableLabel">检验人</td>
          <td class="tdContent">
            <div v-if="disabledQuality">
              {{supplierApplicationVO.testName}}
            </div>
            <div v-else>
              <el-input v-model="supplierApplicationVO.testName"/>
            </div>

          </td>
          <td class="tableLabel">检验时间</td>
          <td class="tdContent">
            <div v-if="disabledQuality">
              {{supplierApplicationVO.testTime}}
            </div>
            <div v-else>
              <el-date-picker
                  v-model="supplierApplicationVO.testTime"
                  type="date"
                  value-format="yyyy-MM-dd"
                  style="width: 100%"
                  placeholder="请选择日期"/>
            </div>

          </td>
          <td class="tableLabel">检验结果</td>
          <td class="tdContent">
            <div v-if="disabledQuality">
              {{supplierApplicationVO.testResult}}
            </div>
            <div v-else>
              <el-checkbox-group v-model="testResult" :max="1" @change="changeTestResult()">
                <el-checkbox label="合格"/>
                <el-checkbox label="不合格"/>
              </el-checkbox-group>
            </div>

          </td>
        </tr>
        <tr v-if="showTech">
          <td class="tableLabel">物料是否引入</td>
          <td class="tdContent">
            <div v-if="disabledTech">
              {{supplierApplicationVO.approveMaterial}}
            </div>
            <div v-else>
              <el-checkbox-group v-model="approveMaterial" :max="1" @change="changeApproveMaterial()">
                <el-checkbox label="是"/>
                <el-checkbox label="否"/>
              </el-checkbox-group>
            </div>
          </td>
          <td class="tableLabel">供方是否引入</td>
          <td class="tdContent">
            <div v-if="disabledTech">
              {{supplierApplicationVO.approveSupplier}}
            </div>
            <div v-else>
              <el-checkbox-group v-model="approveSupplier" :max="1" @change="changeTestSupplier()">
                <el-checkbox label="是"/>
                <el-checkbox label="否"/>
              </el-checkbox-group>
            </div>
          </td>
          <td class="tableLabel">资料是否齐全</td>
          <td class="tdContent" colspan="3">
            <div v-if="disabledTech">
              {{supplierApplicationVO.approveFile}}
            </div>
            <div v-else>
              <el-checkbox-group v-model="approveFile" :max="1" @change="changeTestFile()">
                <el-checkbox label="是"/>
                <el-checkbox label="否"/>
              </el-checkbox-group>
            </div>
          </td>
        </tr>
        </tbody>
      </table>
    </div>
    <div>
      <div
          style="border-bottom: 1px solid #ddd; margin-bottom: 10px; padding-bottom: 5px; font-size: 16px; margin-top: 20px">
        附件
      </div>
      <upload-file
          ref="upload"
          :show-file-list="false"
          :auth-index="authIndex"
          style="text-align: right;margin-top: 2px;"
          @upload-success="uploadSuccess"/>
      <el-table border :data="supplierApplicationVO.attachments">
        <el-table-column type="index" align="center" label="#" width="55"/>
        <el-table-column prop="fileName" align="left" label="名称">
          <template slot-scope="scope">
            <a @click="downLoad(scope.row)">{{ scope.row.fileName }}</a>
          </template>
        </el-table-column>
        <el-table-column prop="creatorName" align="left" label="创建人" width="100"/>
        <el-table-column prop="createTime" align="left" label="创建时间" width="140"/>
        <el-table-column label="操作" align="center" width="120" class-name="vm-table_operate">
          <template slot-scope="scope">
            <el-button type="danger" :disabled="scope.row.createTime"
                       @click="supplierApplicationVO.attachments.splice(scope.$index, 1)">删除
            </el-button>
          </template>
        </el-table-column>
        <!--        <el-table-column v-if="showEngeUpload" label="操作" align="center" width="120" class-name="vm-table_operate">-->
        <!--          <template slot-scope="scope">-->
        <!--            <el-button type="danger" :disabled="userId!==scope.row.creatorId"-->
        <!--                       @click="supplierApplicationVO.attachments.splice(scope.$index, 1)">删除-->
        <!--            </el-button>-->
        <!--          </template>-->
        <!--        </el-table-column>-->
      </el-table>
    </div>
    <handle-detail :bill-id="billId" :bill-type="billType" :sequ-id="sequId"/>
  </div>
</template>
<script>
import HandleDetail from "@/views/workFlow/HandleDetail";
import constant from "@/util/constant";
import UploadFile from "@/components/UploadFile";
import loginUtil from "@/util/loginUtil";

export default {
  name: "SupplierApplicationPreview",
  components: {HandleDetail, UploadFile},
  props: {
    params: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      authIndex: 653,
      billId: "",
      billType: "18",
      sequId: "",
      constant,
      nodeId: "",
      userId: 0,
      isHidden: false,
      showQuality:false,
      showTech:false,
      disabledQuality: false,
      disabledTech: false,
      testReport: [],
      testResult: [],
      approveMaterial: [],
      approveFile: [],
      approveSupplier: [],
      supplierApplicationVO: {
        pkId: 0,
        no: "",
        status: 0,
        importReason: "",
        canReplace: "",
        developerName: "",
        customerName: "",
        productSpecification: "",
        materialName: "",
        materialSpecification: "",
        materialProperty: "",
        materialCode: "",
        standardType: "",
        specification: "",
        useType: "",
        note: "",
        supplierName: "",
        supplierContact: "",
        supplierTel: "",
        supplierType: "",
        roHS: "",
        roHSMaterial: "",
        materialStandard: "",
        currentSupplier: "",
        materialPropertyValue: "",
        testReport: "",
        testName: "",
        testTime: "",
        testResult: "",
        approveMaterial: "",
        approveFile: "",
        approveSupplier: "",
        attachments: [],
      },
    };
  },
  watch: {
    $route: {
      immediate: true,
      handler(val) {
        if (val.query.billId) {
          this.billId = val.query.billId;
          this.billType = val.query.billType;
          this.sequId = val.query.sequId;
          this.userId = loginUtil.getUserId();
          this.getData(val.query.billId);
          this.getNodeValue();
        }
      },
    },
    params: {
      handler() {
        this.doApprove();
      },
    },
  },
  methods: {
    getData() {
      this.$emit("loading-status", {"loading": true});
      this.$http
          .get("basic", `supplierApplications/${this.billId}`)
          .then(resp => {
            this.$emit("loading-status", {"loading": false});
            this.supplierApplicationVO = resp.data;

            this.supplierApplicationVO.testReport.split(",").forEach((item) => {
              if (item) {
                this.testReport.push(item);
              }
            });
            this.supplierApplicationVO.testResult.split(",").forEach((item) => {
              if (item) {
                this.testResult.push(item);
              }
            });
            this.supplierApplicationVO.approveMaterial.split(",").forEach((item) => {
              if (item) {
                this.approveMaterial.push(item);
              }
            });
            this.supplierApplicationVO.approveFile.split(",").forEach((item) => {
              if (item) {
                this.approveFile.push(item);
              }
            });
            this.supplierApplicationVO.approveSupplier.split(",").forEach((item) => {
              if (item) {
                this.approveSupplier.push(item);
              }
            });

          });
    },

    changeTestReport() {
      this.supplierApplicationVO.testReport = "";
      if (this.testReport) {
        this.supplierApplicationVO.testReport = this.testReport.join(",");
      }
    },
    changeTestResult() {
      this.supplierApplicationVO.testResult = "";
      if (this.testResult) {
        this.supplierApplicationVO.testResult = this.testResult.join(",");
      }
    },
    changeApproveMaterial() {
      this.supplierApplicationVO.approveMaterial = "";
      if (this.approveMaterial) {
        this.supplierApplicationVO.approveMaterial = this.approveMaterial.join(",");
      }
    },
    changeTestSupplier() {
      this.supplierApplicationVO.approveSupplier = "";
      if (this.approveSupplier) {
        this.supplierApplicationVO.approveSupplier = this.approveSupplier.join(",");
      }
    },
    changeTestFile() {
      this.supplierApplicationVO.approveFile = "";
      if (this.approveFile) {
        this.supplierApplicationVO.approveFile = this.approveFile.join(",");
      }
    },

    // 下载
    downLoad(row) {
      this.$http.get("basic", `files/getDownloadUrl?key=${encodeURIComponent(row.filePath)}`).then((res) => {
        if (res.success) {
          window.open(res.data);
        }
      });
    },

    getNodeValue() {
      let params = {
        billType: this.billType,
        billId: this.billId,
        sequId: this.sequId,
      };
      this.$http.get("basic", "applications/approve", params).then((resp) => {
        this.nodeId = resp.data.nodeId;
        console.log(this.nodeId);
        this.initNode();
        this.checkNode();
      });
    },

    initNode() {
      this.showQuality=false;
      this.showTech=false;
      this.disabledQuality=false;
      this.disabledTech=false;
    },

    checkNode() {
      //总经理审核
      if (this.nodeId == "GeneralApprove") {
        this.showQuality=true;
        this.showTech=true;
        this.disabledQuality=true;
        this.disabledTech=true;
      }
      if ("QualityApprove" == this.nodeId) {
        this.showQuality=true;
        this.showTech=false;
        this.disabledQuality=false;
        this.disabledTech=false;
      }

      if (this.nodeId == "TechApprove") {
        this.showQuality=true;
        this.showTech=true;
        this.disabledQuality=true;
        this.disabledTech=false;
      }

    },

    doApprove() {
      // if (this.params.actionType === 0) {
      //   if (this.nodeId == "FmTechManageApprove") {
      //     if (this.supplierApplicationVO.engeApproveId == null || this.supplierApplicationVO.engeApproveId === 0)
      //       return this.$message.error("项目工程师不可为空！！！");
      //   }
      // }

      this.updateBill();

      let billParam = [];
      let approveVar = "";
      let params = {
        billId: parseInt(this.billId),
        billType: parseInt(this.billType),
        sequId: parseInt(this.sequId),
        actionType: this.params.actionType,
        approveNote: this.params.approveNote,
        untreadedFlowId: this.params.untreadedFlowId,
        transferTo: this.params.transferTo,
        approveVar: approveVar,
        billParam: JSON.stringify(billParam),
      };
      this.$emit("loading-status", {loading: true});
      this.$http
          .post("basic", "applications/doApprove", params)
          .then((resp) => {
            this.$emit("loading-status", {loading: false});
            if (resp.success) {
              this.$message.success("保存成功");
              // if (["regionManager", "fiApprove", "GeneralManager"].includes(this.nodeId)) {
              //   this.updateHandle();
              // }
              // 关闭标签
              this.$bus.$emit("closeTag", this.$route);
              this.$router.push({
                path: "/workFlow/SupplierApplication",
              });
            }
          })
          .catch(() => {

            this.$emit("loading-status", {loading: false});
          });
    },

    updateBill() {
      this.$http.post("basic", "supplierApplications/save/0", this.supplierApplicationVO)
          .then(() => {
          })
          .catch(() => {
          });
    },
    uploadSuccess(fileList) {
      if (fileList.length) {
        const params = {
          fileName: fileList[0].name,
          filePath: fileList[0].key,
          creatorId: loginUtil.getUserId(),
          creatorName: loginUtil.getName(),
        };
        this.supplierApplicationVO.attachments.push(params);
      }
    },

  },
};
</script>
<style lang="scss">
.body {
  .el-button + .el-button {
    margin-left: 0;
  }

  .el-tabs--border-card > .el-tabs__content {
    padding: 10px;
  }

  .body-btn {
    margin-bottom: 2px;
    margin-right: 2px;
  }

  table.gridtable {
    font-family: verdana, arial, sans-serif;
    font-size: 11px;
    color: #333333;
    border-width: 1px;
    border-color: #dddddd;
    border-collapse: collapse;
    width: 100%;
  }

  table.gridtable th {
    text-align: left;
    border-width: 1px;
    padding: 8px;
    border-style: solid;
    border-color: #dddddd;
    background-color: #D1E6F5;
  }

  table.gridtable td {
    border-width: 1px;
    padding: 8px;
    border-style: solid;
    border-color: #dddddd;
  }

  .tableLabel {
    width: 10%;
    text-align: right;
    background-color: #D1E6F5;
  }
}
</style>
